import { render, staticRenderFns } from "./promoterReviewe.vue?vue&type=template&id=5dcfcde0&scoped=true"
import script from "./promoterReviewe.vue?vue&type=script&lang=js"
export * from "./promoterReviewe.vue?vue&type=script&lang=js"
import style0 from "./promoterReviewe.vue?vue&type=style&index=0&id=5dcfcde0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcfcde0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dcfcde0')) {
      api.createRecord('5dcfcde0', component.options)
    } else {
      api.reload('5dcfcde0', component.options)
    }
    module.hot.accept("./promoterReviewe.vue?vue&type=template&id=5dcfcde0&scoped=true", function () {
      api.rerender('5dcfcde0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw/promoterReviewe.vue"
export default component.exports